// import { useTranslation } from "react-i18next";
// import { NavLink } from "react-router-dom";
// import { getNavClass } from "../utils/constants";

// export const NavLinkComponent = ({ to, label }) => {
//   const { t } = useTranslation();
//   return (
//     <NavLink to={to} className={getNavClass}>
//       {t(label)}
//     </NavLink>
//   );
// };

import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import { getNavClass } from "../utils/constants";

export const NavLinkComponent = ({ to, label, activePaths = [] }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const isCustomActive =
    activePaths.length > 0 && activePaths.includes(location.pathname);

  return (
    <NavLink
      to={to}
      className={(navData) =>
        isCustomActive
          ? getNavClass({ ...navData, isActive: true })
          : getNavClass(navData)
      }
    >
      {t(label)}
    </NavLink>
  );
};
